import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import { euro } from './Variables';
import "./statement.css";
import "./largeDetails.css";
import { InfoBlock } from './InfoBlock';
import { Gateway } from '../BaseUrl';
import { monthName, shortDateString, dateAndMonth, IsEmpty } from '../Functions/Generic';

export class Statements extends Component {
    displayName = Statements.name
    _isMounted = false;

    constructor(props) {
        super(props);
        this.props.changeLogo("statement");

        this.state = {
            loan: this.props.loan || {},

            statement: []
        }

        this.getSummary = this.getSummary.bind(this);             
    }

    componentDidMount() {
        this._isMounted = true;
        if (!IsEmpty(this.state.loan)) {
            this.getSummary();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    orderStatement(data = []) {
        var yearArray2 = {};
        data.forEach((item, index) => {
            var d = new Date(item.transactionDate);
            if (yearArray2[d.getFullYear()] == null || yearArray2[d.getFullYear()] == undefined) {
                yearArray2[d.getFullYear()] = [];
            }        
            yearArray2[d.getFullYear()].push(item);
        });

        for (const i in yearArray2) {
            var jan = [], feb = [], mar = [], apr = [], may = [], jun = [], jul = [], aug = [], sep = [], oct = [], nov = [], dec = [];
            yearArray2[i].forEach((item) => {
                var d = new Date(item.transactionDate);
                switch (d.getMonth()) {
                    case 0: jan.push(item); break;
                    case 1: feb.push(item); break;
                    case 2: mar.push(item); break;
                    case 3: apr.push(item); break;
                    case 4: may.push(item); break;
                    case 5: jun.push(item); break;
                    case 6: jul.push(item); break;
                    case 7: aug.push(item); break;
                    case 8: sep.push(item); break;
                    case 9: oct.push(item); break;
                    case 10: nov.push(item); break;
                    case 11: dec.push(item); break;
                }
            })
            yearArray2[i] = [dec, nov, oct, sep, aug, jul, jun, may, apr, mar, feb, jan]
        }
        return yearArray2;
    }

    getSummary() {
        fetch(Gateway + '/loan/' + this.state.loan.loanReferenceNumber + '/Statement', {
            method: "GET",
            headers: {
                "Authorization": "Bearer " + this.props.token
            }
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                if (response.status == 401) {
                    this.props.Logout(true)
                } else {
                    throw Error(response.status + ": " + response.statusText);
                }
            }
        }).then(data => {
            if (data != null && this._isMounted) {
                this.setState({
                    statement: this.orderStatement(data),
                    loading: false
                });
            }
            
        }).catch((e) => {
            console.log("error", e);
            if (this._isMounted) {
                this.setState({
                    loading: false
                });
            }
        });
    };

    render() {
        var arr = this.state.statement;
        var Entry = [];

        Object.keys(arr).sort(function (a, b) {
            return b - a;
        }).forEach((item, index) => {
            arr[item].forEach((i, n) => {
                    Entry.push(i);   
            });
        });

        return (
            <div style={{ width: "100%" }}>
                <div className="statement-header desktop-only">
                    <div className="large-title">
                        <h2> Your statement </h2>
                    </div>
                    <div className="container large-details">
                        <div className="large-detail">
                            <label>Agreement Number</label>
                            <p>{this.props.summary.loanReferenceNumber}</p>
                        </div>
                        <div className="large-detail">
                            <label>Current Balance</label>
                            <p>€{(this.props.summary.currentBalance || 0).toFixed(2)}</p>
                        </div>
                        <div className="large-detail">
                            <label>Monthly Instalment</label>
                            <p>€{(this.props.summary.rmiAmount || 0).toFixed(2)}</p>
                        </div>
                    </div>
                </div>
                {
                //<div className="container text-center mobile-only">
                //    <button style={{ margin: "15px 0" }} type="button" className="btn btn-lg btn-default">
                //        Print Statement
                //    </button>
                //</div>
                    //<div className="desktop-only">
                    //    <div className="statement-buttons">
                    //        <button type="button" className="btn btn-secondary">Stop paper statements</button>
                    //        <button type="button" className="btn btn-secondary">View full statements</button>
                    //    </div>
                    //</div>
                }
                <div className="container">

                    {
                        Entry.map((item, index) => {
                            if (item.length > 0) {
                                return <MonthlyEntry key={index} Entries={item} month={index} />
                            }
                        })
                    }

                    <div style={{ maxWidth: "275px", margin: "auto" }}>

                        <InfoBlock title={"Lenders Signature"} >
                            <div>
                                <div className="signature">Daniel Hawkins</div>
                                <div>Daniel Hawkins</div>
                                <div><small>On behalf of Amigo Ireland</small></div>
                            </div>
                        </InfoBlock>
                    </div>
                </div>                
            </div>
        );
    }
}

class MonthlyEntry extends Component {
    render() {
        return (
            <div className="monthlyEntry">
                <div className="month">
                    <p>{monthName[this.props.month%12]} {this.props.year}</p>
                </div>
                {
                    this.props.Entries.map((item, index) => {
                        return <Entry key={index} {...item} directDebit={true} />
                    })
                }                
            </div>
        );
    }
}

class Entry extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            open: false
        };
    }

    handleClick = () => {
        this.refs.toggleS.classList.toggle('selectedEntry');
        this.refs.arrow.classList.toggle('fa-angle-up');
        this.refs.arrow.classList.toggle('fa-angle-down');
        this.setState({ open: !this.state.open })
    }

    render() {
        const {
            transactionDate,
            amount,
            fullDescription,
            shortDescription,
            totalArrears,
            currentBalance
        } = this.props;
        var afterType = ((shortDescription || "").indexOf("Interest") >= 0) ? "interest" : "this payment";
        return (
            <div className="entry">
                <div ref="toggleS" className="entryTitle" onClick={this.handleClick}>
                    <div>
                        <label>{shortDescription}</label>
                        <p>{dateAndMonth(transactionDate)}</p>
                    </div>
                    <div>
                        <label style={{ fontSize: "16px" }}>{euro}{amount.toFixed(2)}</label> <i ref="arrow" style={{fontSize: "20px", color: "#004561"}} className="fas fa-angle-down"></i>
                    </div>
                </div>
                <Collapse className="entryDetail" in={this.state.open}>
                    <div>                        
                        <p className="text-center">{fullDescription}</p>
                        <div>
                            <label>Payment Amount:</label>
                            <p><span>{euro}{amount.toFixed(2)}</span>  </p>
                        </div>
                        <div>
                            <label>Payment Type:</label>
                            <p>{shortDescription}</p>
                        </div>
                        <div>
                            <label>Balance after {afterType}:</label>
                            <p>{euro}{currentBalance.toFixed(2)}</p>
                        </div>
                        <div>
                            <label>Arrears:</label>
                            <p>{euro}{totalArrears >= 0 ? (totalArrears || 0).toFixed(2) : <span>0.00</span>}</p>
                        </div>
                        <div>
                            <label>Leaders signature:</label>
                            <p><span className="signature">Daniel Hawkins</span> - On behalf of Amigo Ireland</p>
                        </div>
                    </div>
                </Collapse>
            </div>
        );
    }
}

Entry.defaultProps = {
    transactionDate: "",
    amount: 0,
    fullDescription: "",
    shortDescription: "",
    totalArrears: 0,
    currentBalance: 0
};


// WEBPACK FOOTER //
// ./src/components/Statements.js